export default "__VITE_ASSET__Bp$UBEtf__"